"use strict";

var _Object$keys2 = require("@babel/runtime-corejs2/core-js/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");

var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.mergeTranslation = mergeTranslation;
exports["default"] = useI18n;
exports.getI18nObject = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));

var _set = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/set"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _react = _interopRequireDefault(require("react"));

var _L10nContext = _interopRequireDefault(require("./L10nContext"));

var _i18n2 = require("./i18n");

var _locales = _interopRequireDefault(require("./locales"));

function ownKeys(object, enumerableOnly) { var keys = _Object$keys2(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

function mergeTranslation() {
  var customLocales = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var paprikaLocales = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var result = {};
  var allLocales = new _set["default"]([].concat((0, _toConsumableArray2["default"])((0, _keys["default"])(paprikaLocales)), (0, _toConsumableArray2["default"])((0, _keys["default"])(customLocales))));
  allLocales.forEach(function (lang) {
    result[lang] = {
      translation: _objectSpread(_objectSpread({}, paprikaLocales[lang] ? paprikaLocales[lang].translation : {}), customLocales[lang] ? customLocales[lang].translation : {})
    };
  });
  return result;
}

var getI18nObject = function getI18nObject() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "en";
  var locales = arguments.length > 1 ? arguments[1] : undefined;

  var _i18n = (0, _i18n2.i18n)(locales ? mergeTranslation(locales, _locales["default"]) : _locales["default"]);

  return {
    locale: locale,
    t: _i18n.getFixedT(locale),
    i18n: _i18n
  };
};

exports.getI18nObject = getI18nObject;

function useI18n() {
  var _i18n = _react["default"].useContext(_L10nContext["default"]);

  return _i18n || getI18nObject();
}
//# sourceMappingURL=useI18n.js.map